<main class="legal-page">
  <div class="legal-page__container">
    <a routerLink="/" class="legal-page__back">← Vissza a főoldalra</a>
    <h1 class="legal-page__title">Impresszum</h1>
    @if (impressum(); as data) {
      <dl class="legal-page__list">
        <div class="legal-page__row">
          <dt>Szolgáltató neve</dt>
          <dd>{{ data.companyName }}</dd>
        </div>
        <div class="legal-page__row">
          <dt>Székhely</dt>
          <dd>{{ data.address }}</dd>
        </div>
        <div class="legal-page__row">
          <dt>E-mail</dt>
          <dd><a [href]="'mailto:' + data.email">{{ data.email }}</a></dd>
        </div>
        <div class="legal-page__row">
          <dt>Telefon</dt>
          <dd>{{ data.phone }}</dd>
        </div>
        <div class="legal-page__row">
          <dt>Adószám</dt>
          <dd>{{ data.taxNumber }}</dd>
        </div>
        <div class="legal-page__row">
          <dt>Nyilvántartási szám</dt>
          <dd>{{ data.registrationNumber }}</dd>
        </div>
      </dl>
      <!-- <p class="legal-page__disclaimer">{{ data.disclaimer }}</p> -->
    }
  </div>
</main>
